import classNames from "classnames";
import styles from "./Preloader.module.scss";

export const Loader = () => {
    return (
        <div className={classNames(styles['preloader__loader'])} />
    );
}
